import { styled } from '@/styled-system/jsx';
import Container from 'app/shared/core/Container';

// HdpSummaryAddress styles
export const StyledHdpAddressDisplayName = styled('h1', {
  base: {
    color: 'hpxBlue600',
    fontWeight: 'bold',
    fontSize: '22px',
    lineHeight: '24px',
    md: {
      fontSize: '28px',
      lineHeight: '24px',
    },
  },
});

export const StyledHdpAddressDisplayWrapper = styled(Container as React.ComponentType<unknown>, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '8px',
    marginTop: '8px',
    marginBottom: '16px',
    md: {
      marginTop: '16px',
    },
  },
});

export const StyledHdpAddressDisplayAddress = styled('h2', {
  base: {
    color: 'hpxGrey500',
  },
});

export const StyledHdpPhoneIcon = styled('img', {
  base: {
    width: '14px',
    paddingBottom: '2px',
  },
});

// HdpSummaryLinks styles
export const StyledHdpLinksWrapper = styled(Container as React.ComponentType<unknown>, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '8px',
    marginBottom: '16px',
  },
});

// HdpSummaryListingTags styles
export const StyledListingRestrictionTag = styled('span', {
  base: {
    display: 'inline-block',
    background: 'hpxTeal100',
    color: 'hpxBlue500',
    fontSize: 'sm',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '16px',
    paddingRight: '16px',
    borderRadius: '16px',
    verticalAlign: 'bottom',
    marginRight: '8px',
  },
});

export const StyledListingTagWrapper = styled('div', {
  base: {
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'hpxGrey100',
  },
});

// HdpEmergencyBanner styles
export const StyledEmergencyBanner = styled('div', {
  base: {
    borderWidth: '0.5px',
    borderStyle: 'solid',
    borderColor: '#33a592',
    borderRadius: '4px',
    backgroundColor: 'hpxTeal100',
    marginBottom: '16px',
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: '8px',
    paddingRight: '8px',
    width: '100%',
  },
});

export const StyledBannerContent = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
  },
});

export const StyledAlertImage = styled('img', {
  base: {
    flexShrink: 0,
  },
});

export const StyledBannerText = styled('div', {
  base: {
    flex: '1',
    lineHeight: '24px',
  },
});

// HdpSummaryDetails styles
export const StyledHdpDetailsWrapper = styled(Container as React.ComponentType<unknown>, {
  base: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '8px',
  },
});

export const StyledDetailedRow = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: '0px',
    marginRight: '0px',
    marginBottom: '16px',
    marginLeft: '0px',
    gap: '24px',
  },
  variants: {
    isRoomForRent: {
      true: {
        alignItems: 'flex-start',
      },
    },
  },
});

export const StyledDetailItem = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '4px',
  },
});

export const StyledDetailValue = styled('div', {
  base: {
    fontWeight: '600',
    color: 'hpxBlue600',
  },
});

export const StyledDetailLabel = styled('div', {
  base: {
    color: 'hpxGrey500',
    fontWeight: '400',
  },
});

export const StyledPriceRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
});
